import { type TooltipProps } from '@mui/material'

import { InfoTooltip } from './InfoTooltip'

export function ListenRepeatTooltips({
  children,
  placement,
}: {
  children: React.ReactElement<any, any>
  placement?: TooltipProps['placement']
}) {
  return (
    <InfoTooltip placement={placement} title="AI compares student speech to your provided text.">
      {children}
    </InfoTooltip>
  )
}
